import * as Yup from 'yup'

export const getValidationSchema = t =>
  Yup.object().shape({
    category: Yup.string().required(t('validation.category')),
    title: Yup.string().required(t('validation.title')),
    budget: Yup.number().required(t("validation.budget"))
  })
